import { render } from "./a-time-skelet.vue?vue&type=template&id=7cd5f05c&scoped=true"
const script = {}

import "./a-time-skelet.vue?vue&type=style&index=0&id=7cd5f05c&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd5f05c"]])

export default __exports__